<template>
  <CommonLayout header="floristHeader" footer="floristFooter">
    <div class="p-5" style="min-height: 400px">
      <div class="text-center m-5" id="msgBox">
        <template v-for="(msg, index) in mainMsg">
          <p class="h5" :key="index">{{msg}}</p>
        </template>
        <b-spinner v-show="spinnerShow" class="mt-5"></b-spinner>
      </div>
    </div>
    <CommonModal ref="commonModal" />
    <div class="p-2">
      <p class="mb-0 text-light h2" id="logo" style="cursor:default;user-select:none" v-if="tabErrorShow">
        <a href="javascript:void(0)" style="font-size: 11px; color:red" @click="clickTabIni">
          {{ this.consts.messages.clearMultipleStart }}
          <!--※他のタブで打合せ操作を行っていないのに、「複数のタブで打合せ操作を行うことはできない」旨のエラーが発生している場合-->
        </a>
        <CommonModal ref="commonModalForTabIni" @confirmOk="deleteTabInfo" />
      </p>
    </div>
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import LoginModel from '@/models/LoginModel'
import MeetingStartModel from '@/models/MeetingStartModel'
import fstore from '@/store/florist-store'
import CommonLogModel from '@/models/CommonLogModel'
import ProdInstStartModel from '@/models/ProdInstStartModel'
import SearchFacilityInfoModel from '@/models/SearchFacilityInfoModel'

export default {
  name: 'FloristMeetingIndex',
  components: {CommonLayout, LoginModel, CommonModal},
  data () {
    return {
      spinnerShow: true,
      mainMsg: [
        'ログイン中です。',
        'しばらくお待ち下さい'
      ],
      signalingData: [],
      tabErrorShow: false
    }
  },
  computed: {
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    }
  },
  methods: {
    auth: async function () {
      try {
        const [projectNumber, password] = this.getProjectNumberAndPassword()
        const afterMTG = this.getAfterMTG()
        const prodInst = this.getProdInst()
        const referenceFlag = this.getReferenceFlag()
        const userName = this.getUserName()

        await this.login(projectNumber, password, afterMTG, prodInst)

        let loginStatus = {
          'beforeLogin': '1',
          'afterMTG': afterMTG,
          'prodInst': prodInst,
          'referenceFlag': referenceFlag,
          'userName': userName
        }
        localStorage.setItem('loginStatus', JSON.stringify(loginStatus))
        let targetPath = '/florist/meeting/agenda'
        if (prodInst !== '1') {
          const meetingStartModel = await this.meetingStart()

          sessionStorage.meeting = await JSON.stringify(meetingStartModel.meeting)
          sessionStorage.attendee = await JSON.stringify(meetingStartModel.attendee)

          // DB上のアドレスへの画面遷移

          let urlUpdatTime = Date.parse(meetingStartModel.meetingURL['updatedDateTime'] + '+09:00')
          // DBのデータが一定時間以内ならDBのURLに遷移する
          if (Date.now() - urlUpdatTime < this.config.UrlTransitionTimeLimit) {
            let meetingurl = meetingStartModel.meetingURL['currentURLPath']
            if (meetingurl !== '') {
              targetPath = '/florist/' + meetingurl
              if (meetingStartModel.meetingURL['operatingPrivilege'] === '0') {
                fstore.commit('setIsOperationPossible', true)
              } else {
                fstore.commit('setIsOperationPossible', false)
              }

              if (meetingStartModel.meetingURL['customerDisplayFlag'] === '1') {
                fstore.commit('setCustomerDisplayFlag', true)
              } else {
                fstore.commit('setCustomerDisplayFlag', false)
              }

              const suggestionData = meetingStartModel.meetingURL['suggestionData']
              if (suggestionData) {
                localStorage.setItem('suggestionData', suggestionData)
              }
            }
          }
          const facilityData = await SearchFacilityInfoModel.getApi(this.$bvModal, projectNumber, (facilityData) => {})
          if ('records' in facilityData && facilityData['records'].length > 0 && facilityData['records'][0]['スペック提案時の初期表示']['value'].length > 0) {
            localStorage.setItem('specFirstDisplay', true)
          } else {
            localStorage.setItem('specFirstDisplay', false)
          }

          if ('records' in facilityData && facilityData['records'].length > 0 && facilityData['records'][0]['商品提案時の初期表示']['value'].length > 0) {
            localStorage.setItem('productFirstDisplay', true)
          } else {
            localStorage.setItem('productFirstDisplay', false)
          }

          if ('records' in facilityData && facilityData['records'].length > 0 && facilityData['records'][0]['商品提案時の初期表示_注力商品']['value'].length > 0) {
            localStorage.setItem('focusProductFirstDisplay', true)
          } else {
            localStorage.setItem('focusProductFirstDisplay', false)
          }

          CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'current_path': this.$route.path, 'reloadPath': targetPath}, () => {})
        } else {
          await this.prodInstStart()
          // 制作指示画面の場合はhearing画面に遷移する
          targetPath = '/florist/meeting/hearing'
        }
        // ログイン完了したため、ログイン前フラグを'0'に更新
        loginStatus['beforeLogin'] = '0'
        localStorage.setItem('loginStatus', JSON.stringify(loginStatus))

        this.$router.push(targetPath)
      } catch (err) {
        console.log(err)
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'errorMessage': err}, () => {})
      }
    },
    // エラー時などの共通処理
    authStop () {
      this.mainMsg = null
      this.mainMsg = Object.assign([], this.mainMsg, ['最初からやりなおしてください'])
      this.spinnerShow = false
    },
    // GETパラメータを取得
    getProjectNumberAndPassword () {
      if (!this.$route.query.projectNumber) {
        this.$refs.commonModal.msgBoxOk('予期せぬエラーが発生しました')
        this.authStop()
        throw new Error('auth error')
      }

      return [this.$route.query.projectNumber, this.$route.query.password]
    },
    // login api 認証
    login: async function (projectNumber, password, afterMTG, prodInst) {
      console.log(localStorage.getItem('tabInfo'))
      if (localStorage.getItem('tabInfo')) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.multipleStart)
        this.authStop()
        this.tabErrorShow = true
        throw new Error(this.consts.errorMsg.multipleStart)
      }

      const reqData = {
        projectNumber: projectNumber,
        password: password,
        afterMTG: afterMTG,
        prodInst: prodInst,
        attendeeType: this.consts.attendeeType.florist
      }

      const loginModel = await LoginModel.apiSetStore(this.$bvModal, reqData, null, (err) => {
        let errorMsg = 'エラーが発生しました'
        if (err.response && err.response.data && err.response.data.message) {
          errorMsg = err.response.data.message
        } else if (err.message) {
          errorMsg = err.message
        }
        this.$refs.commonModal.msgBoxOk(errorMsg)
        this.authStop()
        throw new Error('API error.')
      })
      localStorage.isOnlineMeeting = await loginModel.isOnlineMeeting

      // レスポンスが空の場合
      if (!loginModel) {
        this.$refs.commonModal.msgBoxOk('ログイン処理でエラーが発生しました')
        this.authStop()
        throw new Error('API error.')
      // レスポンスにメッセージが入ってる場合
      } else if (loginModel.message) {
        this.$refs.commonModal.msgBoxOk(loginModel.message)
        this.authStop()
        throw new Error('API error.')
      }
    },
    // ミーティングスタート
    meetingStart: async function () {
      const params = {'oneTimePassword': '', 'attendeeType': this.consts.attendeeType.florist}
      const meetingStartModel = await MeetingStartModel.apiSetStore(this.$bvModal, params, null, () => {
        this.authStop()
        throw new Error('API error.')
      })
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'current_path': this.$route.path, 'comment': 'ミーティングスタート'}, () => {})

      // レスポンスが空の場合
      if (!meetingStartModel) {
        this.$refs.commonModal.msgBoxOk('通話開始処理でエラーが発生しました')
        this.authStop()
        throw new Error('API error.')
      // レスポンスにメッセージが入ってる場合
      } else if (meetingStartModel.message) {
        this.$refs.commonModal.msgBoxOk(meetingStartModel.message)
        this.authStop()
        throw new Error('API error.')
      }

      return meetingStartModel
    },
    // 制作指示スタート
    prodInstStart: async function () {
      const params = {'attendeeType': this.consts.attendeeType.florist}
      const prodInstStartModel = await ProdInstStartModel.apiSetStore(this.$bvModal, params, null, () => {
        this.authStop()
        throw new Error('API error.')
      })
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'current_path': this.$route.path, 'comment': '制作指示スタート'}, () => {})

      // レスポンスが空の場合
      if (!prodInstStartModel) {
        this.$refs.commonModal.msgBoxOk('制作指示開始処理でエラーが発生しました')
        this.authStop()
        throw new Error('API error.')
      // レスポンスにメッセージが入ってる場合
      } else if (prodInstStartModel.message) {
        this.$refs.commonModal.msgBoxOk(prodInstStartModel.message)
        this.authStop()
        throw new Error('API error.')
      }

      return prodInstStartModel
    },
    getAfterMTG () {
      if (this.$route.query.afterMTG && this.$route.query.afterMTG === '1') {
        return this.$route.query.afterMTG
      }
      return '0'
    },
    getProdInst () {
      if (this.$route.query.prodInst && this.$route.query.prodInst === '1') {
        return this.$route.query.prodInst
      }
      return '0'
    },
    getReferenceFlag () {
      if (this.$route.query.referenceFlag && this.$route.query.referenceFlag === '1') {
        return this.$route.query.referenceFlag
      }
      return '0'
    },
    getUserName () {
      if (this.$route.query.userName) {
        return this.$route.query.userName
      }
      return ''
    },
    clickTabIni () {
      // ブラウザが正常終了せずローカルストレージが初期化されなかった時のため
      this.$refs.commonModalForTabIni.msgBoxConfirm(this.consts.messages.confirmClear)
    },
    deleteTabInfo () {
      localStorage.removeItem('tabInfo')
    }
  },
  created () {
    // ローカルストレージの各種変数を初期化
    localStorage.removeItem('projectTypes')
    localStorage.removeItem('suggestionData')
  },
  mounted () {
    this.auth()
  },
  destroyed () {
    if (MeetingStartModel.getStore()) {
      MeetingStartModel.removeStore()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/FloristMeetingIndex.vue